import { HttpRequest, fetchWrapper } from "@coxauto-ui/core-http";
import { getBaseUrl } from "../config";
import { ResponseError } from "./interfaces/api-error";
import { SendCommunicationRequest } from "./interfaces/send-communication";
import { SendLogCallDetailsRequest } from "./interfaces/send-log-call";
import { sendCommunicationEmail } from "./send-communication-email";
import { sendCommunicationText } from "./send-communication-text";
import { Environment } from "@coxauto-ui/cxm/communications/interfaces";
import authClient from "@coxauto-ui/core-auth-get-auth-client-customer-conversation";
import { SendCommunicationTextRequest } from "./interfaces/send-communication-text";

export async function sendCommunication(
  sendComms: SendCommunicationRequest,
  env: Environment
): Promise<boolean | ResponseError> {
  switch (sendComms.type) {
    case "text": {
      const textRequest: SendCommunicationTextRequest = {
        autoLeadId: sendComms.autoLeadId,
        consumerId: sendComms.consumerId,
        consumerPhoneNumber: sendComms.consumerContactInfo,
        consumerRecordSystem: sendComms.consumerRecordSystem,
        content: sendComms.content,
        attachments: sendComms.attachments,
        fromPhoneNumber: sendComms.fromPhoneNumber,
        taskId: sendComms.taskId,
        serviceAppointmentId: sendComms.serviceAppointmentId,
        mediaInfo: sendComms.mediaInfo
      };
      return await sendCommunicationText(textRequest, env);
    }
    case "email": {
      const emailRequest = {
        autoLeadId: sendComms.autoLeadId,
        consumerId: sendComms.consumerId,
        toAddress: sendComms.consumerContactInfo,
        consumerRecordSystem: sendComms.consumerRecordSystem,
        body: sendComms.content,
        subject: sendComms.subject,
        attachments: sendComms.attachments,
        ccAddresses: sendComms.ccAddresses,
        bccAddresses: sendComms.bccAddresses,
        taskId: sendComms.taskId,
        repairOrderId: sendComms.repairOrderId,
        serviceAppointmentId: sendComms.serviceAppointmentId,
        mediaInfo: sendComms.mediaInfo
      };
      return await sendCommunicationEmail(emailRequest, env);
    }
    default:
      return false;
  }
}

export async function sendLogCall(
  logCallDetails: SendLogCallDetailsRequest,
  env: Environment
) {
  const url = `${getBaseUrl(env)}cxm/logcall`;

  const bridgeJwt = await authClient.getAuth();

  const request: HttpRequest = {
    url,
    method: "POST",
    body: logCallDetails,
    headers: { Authorization: `Bearer ${bridgeJwt}` }
  };
  const response = await fetchWrapper.sendAsyncText(request);
  if (response.statusCode !== 200 || response.hasError) {
    const error: ResponseError = {
      isError: true,
      statusCode: response.statusCode,
      errorResult: response.error
    };
    return error;
  }
  return true;
}
